const constants = {
  MODULEADDR:
    "0xfc1acad6ac59c8a1c44dd930e9a55f4d3a5ba5a560e59b27651d4a70649191bf",
};

export default constants;
